/**
 * Omega-3 pregnancy warning
 */

jQuery(document).ready(function($) {

    if ( typeof vous_l10n === 'undefined' ) { // Ensure l10n is set
        return;
    }
    if ( typeof vous_l10n.enable_omega3_pregnancy_warning === 'undefined' || ! vous_l10n.enable_omega3_pregnancy_warning ) { // Ensure script is enabled
        return;
    }

    var viewed = false; // Has the warning been viewed?

    var modal = $('[data-remodal-id=custom-vitamins-omega3-pregnancy-warning]').remodal({
        hashTracking: false,
        closeOnOutsideClick: false,
        closeOnEscape: false
    });

    $('.js-decline-omega3').click(function(e) {
        if ( ! viewed ) { // Show warning if it hasn't been viewed already
            e.preventDefault();
            modal.open();
        }
    });

    $(document).on('opened', '[data-remodal-id=custom-vitamins-omega3-pregnancy-warning]', function() {
        $.ajax({
            method: 'post',
            url: vous_l10n.ajaxurl,
            data: {
                action: 'custom_vitamins_omega3_warning_record_viewed',
                _wpnonce: $('#_wpnonce_custom_vitamins_omega3_warning_record_viewed').val()
            },
            success: function(response) {
                viewed = true;
            }
        });
    });
    
});
